/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReasonCode } from '../../models/reason-code';

export interface ListReasonCodes$Params {
  entityClass: string;
  entityId: string;
  primaryType: string;
  secondaryTypes?: Array<string>;
}

export function listReasonCodes(
  http: HttpClient,
  rootUrl: string,
  params: ListReasonCodes$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ReasonCode>>> {
  const rb = new RequestBuilder(rootUrl, listReasonCodes.PATH, 'get');
  if (params) {
    rb.path('entityClass', params.entityClass, {});
    rb.path('entityId', params.entityId, {});
    rb.path('primaryType', params.primaryType, {});
    rb.query('secondaryTypes', params.secondaryTypes, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReasonCode>>;
    })
  );
}

listReasonCodes.PATH = '/admin/reason-codes/{entityClass}/{entityId}/{primaryType}';
